<template lang="pug">
div.loyalty-template-comer
  h1.loyalty-template-comer__title {{ $t('loyalty.commerces') }}
  span.loyalty-template-comer__data {{ $t('loyalty.oneCommerce') }}
  div.loyalty-template-comer__espaciado
  h2.loyalty-template-comer__subtitle {{ $t('loyalty.commerce') }}
  ods-tag(type="primary" size="medium").loyalty-template-comer__button {{ data.descomer || $t('loyalty.noData') }}
  div.loyalty-template-comer__espaciado
  h2.loyalty-template-comer__subtitle {{ $t('loyalty.commerceamount') }}
  span.loyalty-template-comer__data {{ data.imp_comer || $t('loyalty.noData') }}
</template>
<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  name: 'DatosPlantilla'
}
</script>
<style lang="scss">
.loyalty-template-comer{
  .ods-module__body{
    padding: 0;
  }
  &__espaciado{
  padding-bottom: rem(24);
  }
  &__data{
   padding-left: rem(32);
   font-size: rem(12);
   line-height: rem(24);
  }

  &__title{
    font-size: rem(14);
    line-height: rem(24);
    margin-bottom: rem(16);
    margin-left: rem(32);
    margin-top: rem(32);
    font-weight: 500;
  }

  &__subtitle{
    font-size: rem(9);
    line-height: rem(16);
    margin-bottom: rem(8);
    text-transform: uppercase;
    color: #6E767D;
    font-weight: 400;
    margin-left: rem(32);
  }

  &__button{
    margin-left: rem(32) !important;
  }
}
</style>
